import { render, staticRenderFns } from "./MainProductTab.vue?vue&type=template&id=60203ba2&scoped=true"
import script from "./MainProductTab.vue?vue&type=script&lang=js"
export * from "./MainProductTab.vue?vue&type=script&lang=js"
import style0 from "./MainProductTab.vue?vue&type=style&index=0&id=60203ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60203ba2",
  null
  
)

export default component.exports